<ng-container *ngIf="activeTab?.key !== 'kfiApplicants'">
    <p class="progress-stepper-title helvetica-neue-regular-font mb-15 vo-heading-regular-18"> {{ referenceDataLabels.ThisStepContains | localizeLabel }}
    </p>
    <div class="progress-stepper-wrapper">
        <ng-container *ngIf="activeTab?.key === 'kfiYourMortgage'">
            <boi-progress-stepper-item *ngIf="sections?.YourMortgage.AboutYourMortgage as status"
                [stepTitle]="referenceDataLabels.AboutTheMortgageId" [status]="status"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
            <boi-progress-stepper-item *ngIf="sections?.YourMortgage.AboutTheFees as status"
                [stepTitle]="referenceDataLabels.AboutTheFeesId" [status]="status"
                [hasSubmitValidationError]="hasSubmitValidationError">
            </boi-progress-stepper-item>
        </ng-container>
    </div>
</ng-container>
